export enum AvgConsentLevel {
    NECESSARY = 1,
    ANALYTICS = 2,
    MARKETING = 3,
}
